import { render, staticRenderFns } from "./edit-info-modal.vue?vue&type=template&id=6209a986&"
import script from "./edit-info-modal.vue?vue&type=script&lang=js&"
export * from "./edit-info-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports